var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 3.66666L6.77665 7.47695C7.21743 7.7855 7.43783 7.93977 7.67755 7.99953C7.8893 8.05231 8.11078 8.05231 8.32253 7.99953C8.56226 7.93977 8.78265 7.7855 9.22343 7.47695L14.6667 3.66666M4.53337 12.3333H11.4667C12.5868 12.3333 13.1469 12.3333 13.5747 12.1153C13.951 11.9236 14.257 11.6176 14.4487 11.2413C14.6667 10.8135 14.6667 10.2534 14.6667 9.13332V4.86666C14.6667 3.74655 14.6667 3.1865 14.4487 2.75868C14.257 2.38235 13.951 2.07639 13.5747 1.88464C13.1469 1.66666 12.5868 1.66666 11.4667 1.66666H4.53337C3.41327 1.66666 2.85322 1.66666 2.42539 1.88464C2.04907 2.07639 1.74311 2.38235 1.55136 2.75868C1.33337 3.1865 1.33337 3.74655 1.33337 4.86666V9.13332C1.33337 10.2534 1.33337 10.8135 1.55136 11.2413C1.74311 11.6176 2.04907 11.9236 2.42539 12.1153C2.85322 12.3333 3.41327 12.3333 4.53337 12.3333Z",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.29f290600bee7d88c7a63cb6c50dec8c.svg";